import Axios from "axios";
import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import Select from "react-select"
import AxiosConfig from "src/utilities/AxiosConfig";
import { qsStringify } from "src/utilities/helper";


interface AddLocatorResponseProps {
    close: Function
    refresh: Function
}

function AddLocatorResponse(props: AddLocatorResponseProps) {
    const [newResponse, setNewResponse] = useState("")
    const [responseCode, setResponseCode] = useState("")
    const [responseUnitType, setResponseUnitType] = useState("EA")
    const close = props.close
    const refresh = props.refresh
    const [locatorCodes, setLocatorCodes] = useState([""])
    const [similarTo, setSimilarTo] = useState(false)

    const GetResponseCodes = () => {
        Axios.get(process.env.REACT_APP_API_URL + "/api/css/billing/ResponseCodes/", AxiosConfig.configValue("min"))
            .then((res) => setLocatorCodes(res.data))
    }

    const InsertLocatorResponse = () => {
        if (!similarTo && newResponse !== "") {
            Axios.post(process.env.REACT_APP_API_URL + '/api/css/InsertLocatorResponse', qsStringify({
                ResponseCode: responseCode,
                ResponseText: newResponse,
                ResponseUnitType: responseUnitType
            }), AxiosConfig.configValue())
                //r-18-lint-cn
                //eslint-disable-next-line
                .then((res) => (close(), refresh()))
        }
        else {
            alert("Response Code already exists")
        }
    }
    useEffect(() => {
        GetResponseCodes()
    }, [])

    return (
        <div>
            <table>
                <tbody className="locatorTableBody">
                    <tr>
                        <td>
                            <span>Response:</span>
                            <Form.Control
                                value={newResponse}
                                id="input"
                                onChange={(e) => setNewResponse(e.target.value)}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <span>Response Code: </span>
                            <Form.Control
                                value={responseCode}
                                type="text"
                                id="input"
                                //r-18-lint-cn
                                //eslint-disable-next-line
                                onChange={(e) => (setResponseCode(e.target.value), setSimilarTo(locatorCodes.find((x) => x === e.target.value) !== undefined))}
                            />
                        </td>
                    </tr>
                    {similarTo ?
                        <tr>
                            <td>
                                <span className="responseTextAlert">Response Code already exists</span>
                            </td>
                        </tr>
                        : null
                    }
                    <tr>
                        <td>
                            <span>Response Unit Type:</span>
                            <Select
                                value={{ label: responseUnitType, value: responseUnitType }}
                                onChange={(e: any) => setResponseUnitType(e.value)}
                                options={[{ label: "EA", value: "EA" }, { label: "HR", value: "HR" }]}
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
            <div className="responseModalButtons">
                <Button variant="primary" onClick={() => InsertLocatorResponse()}>Save</Button>
                <Button variant="secondary" onClick={() => close()}>Cancel</Button>
            </div>
        </div>
    )
}

export default AddLocatorResponse